import Head from 'next/head';
import React from 'react';

import { renderJsonLdScript, getFaqStructuredData } from 'libs/universal/structuredData';
import FAQ_LD from 'components/LP/WeddingPlanning/website/Header/faqLd';

const title = 'Free Wedding Websites with RSVPs & Registry';
const description =
  'Use our website builder to create beautiful, custom wedding websites in minutes. Include RSVPs, registry, and photos. Manage guests, match invites, and more!';

export default function Header(): JSX.Element {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta
        name="keywords"
        content="Wedding websites, Free wedding websites, Best wedding websites, Wedding invitation websites, Wedding invitation websites, Create a wedding website"
      />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta
        property="og:image"
        content="https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/logos/zola-heart-marine.png"
      />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="zola.com" />
      <meta name="twitter:site" content="@zola" />
      <meta name="twitter:card" content="summary" />
      <link rel="canonical" href="https://www.zola.com/wedding-planning/website" />
      {renderJsonLdScript(getFaqStructuredData(FAQ_LD))}
    </Head>
  );
}
